$ = require 'jquery'
Singleton = require '../../pattern/singleton'
Elements = require './elements'
{ forEach, map, flatten, compact, clone } = require 'lodash'
{ toAngle, getRandom, getDir, getHypotenuse, getHeight } = require '../../components/math'
Data = require '../data'

module.exports =
class Bg extends Singleton

  colors: [
    [ 0x09acf1, 0x93defe, 0xffffff, 0xfddd34 ]
    [ 0xff97cc, 0xffc1e0, 0xf0e9e3, 0xffc1e0, 0xff97cc ]
    [ 0xfff53b, 0xededed, 0xffffff, 0xededed, 0xfff53b ]
    [ 0x31da99, 0xa4ffc6, 0xffffff, 0xa4ffc6, 0x31da99 ]
    [ 0xff6d60, 0xffecdb, 0xffffff, 0xffecdb, 0xff6d60 ]
    [ 0x52d4e1, 0xc6f5ff, 0xffffff, 0xc6f5ff, 0x52d4e1 ]
  ]

  freeBgSize: [ null,   84,   82,  154,  155,   78 ]
  lastBgRate: [ 1.22, 1.09, 1.10, 1.10, 1.09, 1.10 ]

  selector        : '.section ~ .section'
  bgSelector      : '.bg'
  headingSelector : '.heading-container .inner'
  contentsSelector: '.contents-container'

  constructor: ->
    super

    @$window = Elements.$window.one
      'pagesLoaded': @onPagesLoaded
      'splashEnded': @onWindowSplashEnded

    @winH = @$window.height()

  on: ->
    @$window.on 'resize', @onWindowResized

  off: ->
    @$window.off 'resize', @onWindowResized

  onPagesLoaded: =>
    @$section    = $ @selector
    @$bg         = @$section.find @bgSelector
    @$heading    = @$section.find @headingSelector
    @$contents   = @$section.find @contentsSelector

  onWindowSplashEnded: =>
    @winH          = @$window.height()
    @viewW         = @getViewW()
    @overH         = getHeight @viewW, toAngle(10)
    @bgLen         = @$bg.length
    @location      = -1
    @isReverse     = false
    @viewH         = []
    @animeEndedArr = []
    @stages        = []
    @renderers     = []
    @$canvases     = []
    @moments       = []
    @momentsGroups = []
    @squares       = []
    @points        = []

    forEach [0...@bgLen], (i) =>
      @viewH[i]         = @getViewH i + 1
      @animeEndedArr[i] = false
      @stages[i]        = new PIXI.Container
      @renderers[i]     = new PIXI.autoDetectRenderer @viewW, @viewH[i],
        backgroundColor: @colors[i][0]
      @$canvases[i]     = $ @renderers[i].view
      @$bg.eq(i).append @renderers[i].view

      @momentsGroups[i] = new PIXI.Container
      @stages[i].addChild @momentsGroups[i]

      @setOrigin i

      @create i
      @redraw i
      @renderers[i].render @stages[i]

  restart: (i) ->
    @isReverse = @location > i

    @reset i

    shift = @overH / 2
    y =
      if !@isReverse then [-shift, shift] else [-shift, -@overH]

    @$canvases[i]
      .css 'visibility', 'hidden'
      .velocity
        translateY: y
      ,
        duration  : 500
        easing    : 'easeInOutCubic'
        visibility: 'visible'

    @animeEndedArr[@location] = true
    @animeEndedArr[i]         = false
    @location                 = i
    @anime(i)
    requestAnimationFrame @animate

  stop: ->
    @animeEndedArr[@location] = true
    @location = -1

  onWindowResized: =>
    @reset @location
    @renderers[@location].render @stages[@location]

  reset: (i) ->
    @winH     = @$window.height()
    @viewW    = @getViewW()
    @overH    = getHeight @viewW, toAngle(10)
    @viewH[i] = @getViewH i + 1
    squareLen = @squares[i].length
    @renderers[i].resize @viewW, @viewH[i]
    @setOrigin i
    @setPoints i

    @renderers[i].backgroundColor =
      if !@isReverse then @colors[i][0] else @colors[i][squareLen - 1]
    forEach @squares[i], (square, j) =>
      square.width      = @viewW
      square.height     = @viewH[i]
      square.position.y = @points[i][j]
      square.tint =
        if !@isReverse
          @colors[i][j]
        else
          @colors[i][(squareLen - 1) - j]

    @$canvases[i].velocity
      translateY: -(@overH / 2)
    , duration: 0

  setOrigin: (i) ->
    @momentsGroups[i].x = @renderers[i].width / 2
    @momentsGroups[i].y = @renderers[i].height / 2

  setPoints: (i) ->
    $heading     = @$heading.eq i
    $contents    = @$contents.eq i
    sectionTop   = @$section.eq(i).offset().top
    headingTop   = $heading.offset().top
    headingW     = $heading.width()
    headingH     = $heading.height()
    headingOverH = getHeight(headingW, toAngle(10)) / 2
    headingY     = (@overH / 2) + (headingTop + headingOverH) - sectionTop
    y = []
    if !@isReverse
      y[0] = 0
      y[1] = headingY
      y[2] = y[1] + headingH
      y[4] = @viewH[i] - (y[1] * @lastBgRate[i])
      y[3] = if i then (y[4] - @freeBgSize[i]) else y[4]
    else
      y[0] = 0
      y[1] = -headingY * @lastBgRate[i]
      y[4] = headingY - @viewH[i]
      y[3] = if i then (y[4] + headingH) else y[4]
      y[2] = if i then (y[1] - @freeBgSize[i]) else (y[4] + headingH)
    @points[i] = map [0...@colors[i].length], (j) =>
      y[j]

  animate: =>
    return if @animeEndedArr[@location]
    @renderers[@location].render @stages[@location]
    requestAnimationFrame @animate

  ###
  create
  ###
  create: (i) ->
    @moments[i] = new PIXI.Container
    @momentsGroups[i].addChild @moments[i]

    @squares[i] = map [0...@colors[i].length], =>
      @createSquares i

  ###
  create squares
  ###
  createSquares: (i) =>
    square = new PIXI.Graphics
    square.pivot.x = 50
    square.pivot.y = 50
    @moments[i].addChild square
    square

  ###
  redraw
  ###
  redraw: (i) ->
    forEach @squares[i], (square, j) =>
      square
        .clear()
        .beginFill 0xffffff
        .drawRect 0, 0, 100, 100
        .endFill()
      square.width  = @viewW
      square.height = @viewH[i]

  ###
  anime
  ###
  anime: (i) ->

    completedCount = 0
    squaresLen     = @squares[i].length

    fromY =
      if !@isReverse then @viewH[i] else -@viewH[i]

    forEach @squares[i], (square, j) =>

      squareTL = new TimelineMax
        delay     : .2 * j
        onUpdate  : =>
          squareTL.pause().kill() if @animeEndedArr[i]
        onComplete: =>
          endCount = (squaresLen - 1)
          if endCount > completedCount
            completedCount++
            if (endCount - 1) is completedCount
              @$window.trigger 'bgJustBeforeEnd', [i]
          else
            @animeEndedArr[i] = true
            @$window.trigger 'bgEnded', [i]

      squareTL
        .add TweenMax.fromTo square, .7,
          y: fromY
        ,
          y: @points[i][j]
          ease: Power4.easeOut

  getViewW: ->
    Math.max @$window.width(), Data.minWidth

  getViewH: (i) ->
    Math.max(@$window.height(), Data.minHeight[i]) + @overH



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/bg.coffee